import script from "./ErrorPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ErrorPanel.vue?vue&type=script&lang=ts&setup=true"

import "./ErrorPanel.vue?vue&type=style&index=0&id=db7bb1c6&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/r1/a/_Build/release/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db7bb1c6"]])

export default __exports__